import { createSlice } from "@reduxjs/toolkit";
import {
  loadLanguageThunk,
  changeLanguageThunk,
  loadTranslationModuleThunk,
} from "../thunks/i18nThunks";
import { mergeTranslations } from "../../i18n/core/loader";

const initialState = {
  language: "en", // Default language
  translations: {
    en: {},
    hi: {},
  }, // Will contain all translations
  supportedLanguages: ["en", "hi"], // List of supported languages
  loading: false, // Loading state
  error: null, // Error state
};

const i18nSlice = createSlice({
  name: "i18n",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      // Save to localStorage for persistence
      localStorage.setItem("preferredLanguage", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle loadLanguage thunk
      .addCase(loadLanguageThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadLanguageThunk.fulfilled, (state, action) => {
        state.loading = false;
        // Store translations for the loaded language
        state.translations[action.payload.language] =
          action.payload.translations;
      })
      .addCase(loadLanguageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load language";
      })

      // Handle loadTranslationModule thunk
      .addCase(loadTranslationModuleThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadTranslationModuleThunk.fulfilled, (state, action) => {
        state.loading = false;
        // Merge the new module translations with existing ones
        const language = action.payload.language;
        const existingTranslations = state.translations[language] || {};
        state.translations[language] = mergeTranslations(
          existingTranslations,
          action.payload.translations
        );
      })
      .addCase(loadTranslationModuleThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load translation module";
      })

      // Handle changeLanguage thunk
      .addCase(changeLanguageThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeLanguageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.language = action.payload.language;
      })
      .addCase(changeLanguageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to change language";
      });
  },
});

export const { setLanguage } = i18nSlice.actions;

export default i18nSlice.reducer;
